import "./Title.css"

export default function Title({ children }) {
    return (
        <span
            className="App-page-title">{children}
        </span>
    )
}
